"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ChatIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.523 4.726C9.729 2.799 12 1.5 14.603 1.5c3.866 0 7 2.865 7 6.4 0 .926-.216 1.806-.603 2.6l1.235 2.783a.636.636 0 01.006.505.571.571 0 01-.778.298l-1.866-.894c.004-.097.006-.195.006-.293 0-4.68-4.068-8.399-9-8.399-.715 0-1.412.078-2.08.226z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.789 17.966a7.016 7.016 0 01-1.385-4.17c0-4.139 3.67-7.495 8.199-7.495 4.528 0 8.198 3.356 8.198 7.496 0 4.14-3.67 7.495-8.198 7.495a8.78 8.78 0 01-3.842-.872l-2.467 2.115a.669.669 0 01-.97-.1.745.745 0 01-.147-.574l.612-3.895z"
  })));
});
ChatIcon.category = 'Communication';
var _default = ChatIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/ChatIcon.js
// module id = 1055
// module chunks = 0